import * as React from 'react';
import { format } from 'date-fns';
import { Calendar as CalendarIcon } from 'lucide-react';
import { SelectSingleEventHandler } from 'react-day-picker';

import { cn } from '../../utils';
import { Button, ButtonProps } from './button';
import { Calendar } from './calendar';
import { Popover, PopoverContent, PopoverTrigger } from './popover';
import { useState } from 'react';

export function DatePicker({
  selected,
  onSelect,
  placeholder,
  disabled,
  triggerButtonVariant,
  triggerClassName,
  disabledDates,
}: {
  selected?: Date;
  onSelect?: SelectSingleEventHandler;
  placeholder?: string;
  disabled?: boolean;
  triggerButtonVariant?: ButtonProps['variant'];
  triggerClassName?: string;
  disabledDates?: (date: Date) => boolean;
}) {
  const [open, onOpenChange] = useState(false);

  return (
    <Popover {...{ open, onOpenChange }}>
      <PopoverTrigger asChild>
        <Button
          disabled={disabled}
          variant={triggerButtonVariant || 'outline'}
          className={cn(
            'w-full justify-start text-left font-normal',
            !selected && 'text-muted-foreground',
            triggerClassName
          )}
          square
        >
          <CalendarIcon className="mr-2 h-4 w-4" />
          {selected ? (
            <div className="flex w-full justify-between items-center">
              {format(selected, 'MMM dd yyyy')}
            </div>
          ) : (
            <span>{placeholder || 'Pick a date'}</span>
          )}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0">
        <Calendar
          mode="single"
          selected={selected}
          defaultMonth={selected}
          onSelect={(...args) => {
            onSelect?.(...args);
            onOpenChange(false);
          }}
          initialFocus
          captionLayout="dropdown-buttons"
          disabled={disabledDates}
          fromYear={1980}
          toYear={2040}
        />
      </PopoverContent>
    </Popover>
  );
}
